import { CommonModule } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { RouterLink } from '@angular/router';
import { GalleryDto, GalleryService } from '@millionshow/api-client';
import { SwiperNavigationComponent } from '../../../../components/swiper-navigation/swiper-navigation.component';
import { SwiperDirective } from '../../../../directives/swiper.directive';
import { SwiperConfigService } from '../../../../services/swiperConfig.service';
import Swiper from 'swiper';
import { NotFoundComponent } from '../../../../components/not-found/not-found.component';

@Component({
  selector: 'app-sketch',
  imports: [
    CommonModule,
    RouterLink,
    SwiperDirective,
    SwiperNavigationComponent,
    NotFoundComponent,
  ],
  templateUrl: './sketch.component.html',
})
export default class SketchComponent {
  private readonly galleryService = inject<GalleryService>(GalleryService);
  private readonly swiperConfigService = inject(SwiperConfigService);

  isEventPage = input<boolean>(false);

  swiper: Swiper | null = null;
  swiperOptions = computed(() =>
    this.swiperConfigService.createConfig(1.5, 3.8)
  );

  $photoGalleries = rxResource({
    params: () => ({ isEventPage: this.isEventPage() }),
    stream: ({ params }) => {
      return this.galleryService.galleryControllerSearchV1({
        pageNo: 1,
        pageSize: 10,
        isExposed: true,
        type: 'PHOTO' as GalleryDto['type'],
        category: (params.isEventPage
          ? 'PROMOTION'
          : 'HOME') as GalleryDto['category'],
        orderBy: 'displayDate',
        align: 'desc',
        sourceType: 'AGRITEX' as const,
      });
    },
  });

  photoGalleries = computed(() => {
    const items = this.$photoGalleries.value()?.items || [];
    return items;
  });

  onSwiperInit(swiper: Swiper): void {
    this.swiper = swiper;
  }

  goToPrev(): void {
    this.swiper?.slidePrev();
  }

  goToNext(): void {
    this.swiper?.slideNext();
  }

  getFirstPhoto(gallery: GalleryDto): string {
    return gallery.photos?.[0] || '';
  }
}
